angular.module('all', [
    'ngFacilityPortal',
    'account',
    'app',
    'display',
    'home',
    'login',
    'ngIdle',
    'ui.bootstrap',

    'aprima-legacy-common',
    'aprima-provider-api',
    'aprima-core-ui',
    'aprima-patient-api',
    'aprima-utils'
]);